import { RefObject, useLayoutEffect, useState } from 'react';
import { useDetectScrollDirection } from '@/hooks';

export const useIntersectionObserver = (
  { targetNodeRef, rootContainer = null }: {targetNodeRef: RefObject<HTMLDivElement>, rootContainer?: RefObject<Element | Document>}
) => {
  const isScrollingUp = useDetectScrollDirection();
  const [showAddToCart, setShowAddToCart] = useState(false);

  useLayoutEffect(() => {
    if (isScrollingUp) {
      setShowAddToCart(false);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowAddToCart(entry.isIntersecting);
        });
      },
      {
        root: rootContainer?.current,
        threshold: 0.02,
      }
    );

    const targetNode = targetNodeRef?.current;

    if (!targetNode) {
      return;
    }

    observer.observe(targetNode);

    return () => {
      if (targetNode) {
        observer.unobserve(targetNode);
      }
    };
  }, [targetNodeRef, rootContainer, isScrollingUp]);

  return showAddToCart;
};
